import { FiDownload } from 'react-icons/fi';
import styles from '../../css/style.module.css';
import filterStyles from './TimesheetFilters.module.css';

const STATUS_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Started', value: 'Started' },
  { label: 'Completed', value: 'Completed' },
];

const TimesheetFilters = ({
  selectedStatus,
  onStatusChange,
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  onApply,
  onClear,
  onDownload,
  downloading,
  hasActiveFilters,
}) => {
  return (
    <div className={filterStyles.filtersWrapper}>
      <div className={filterStyles.statusRow}>
        <div className={styles.jobselectcontainer}>
          <div className={styles.jobStatusContainer}>
            {STATUS_OPTIONS.map(option => (
              <p
                key={option.value || 'all'}
                className={
                  selectedStatus === option.value
                    ? styles.jobOptionTrueactive
                    : styles.jobOptionnotactive
                }
                onClick={() => onStatusChange(option.value)}
              >
                {option.label}
              </p>
            ))}
          </div>
        </div>
        <button
          type="button"
          className={filterStyles.clearButton}
          onClick={onClear}
          disabled={!hasActiveFilters}
        >
          Clear Filters
        </button>
      </div>

      <div className={filterStyles.dateFilterRow}>
        <div className={filterStyles.dateField}>
          <label htmlFor="timesheet-from-date">From Date</label>
          <input
            id="timesheet-from-date"
            type="date"
            value={fromDate}
            onChange={e => onFromDateChange(e.target.value)}
          />
        </div>
        <div className={filterStyles.dateField}>
          <label htmlFor="timesheet-to-date">To Date</label>
          <input
            id="timesheet-to-date"
            type="date"
            value={toDate}
            onChange={e => onToDateChange(e.target.value)}
            min={fromDate || undefined}
          />
        </div>
        <button type="button" className={filterStyles.applyButton} onClick={onApply}>
          Apply Filters
        </button>
        <button
          type="button"
          className={filterStyles.downloadButton}
          onClick={onDownload}
          disabled={downloading || !fromDate || !toDate}
        >
          <FiDownload color="#FFFFFF" size={16} />
          {downloading ? 'Downloading...' : 'Download'}
        </button>
      </div>
    </div>
  );
};

export default TimesheetFilters;
